import * as Model from "@effect/sql/Model";
import { Schema } from "effect";

/**
 * clawd platform — the binary target the artifact was built for.
 * Matches the `agent_platform` Postgres enum.
 *
 * @since 1.0.0
 */
export const AgentPlatform = Schema.Literal("darwin-arm64", "darwin-x64", "linux-amd64");
export type AgentPlatform = Schema.Schema.Type<typeof AgentPlatform>;

/**
 * AgentRelease model — one row per built clawd artifact at one
 * platform. A single CalVer cut produces three rows.
 *
 * Maps 1:1 to the `agent_releases` table.
 *
 * @since 1.0.0
 */
export class AgentRelease extends Model.Class<AgentRelease>("AgentRelease")({
  id: Model.Generated(Schema.String),
  version: Schema.String,
  platform: AgentPlatform,
  downloadUrl: Schema.String,
  sha256: Schema.String,
  sizeBytes: Schema.Number,
  createdAt: Model.DateTimeInsertFromDate,
  createdBy: Schema.NullOr(Schema.String),
  notes: Schema.NullOr(Schema.String),
}) {}
